import React from "react";
import { PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import messages from "../messages.i18n";
export const GoogleMyBusinessAuthError = () => {
    const intl = useIntl();
    return (React.createElement(PeekStack, { height: "100%", justifyContent: "space-between", spacing: 1, pb: 2 },
        React.createElement(PeekTypography, null, intl.formatMessage(messages.spacePublishToGMBAuthErrorDescription1, {
            GoogleAccessLink: (React.createElement("a", { href: "https://myaccount.google.com/permissions", target: "_blank", rel: "noreferrer", onClick: () => {
                    window.open("https://myaccount.google.com/permissions", "_blank");
                } }, intl.formatMessage(messages.spacePublishToGMBAuthErrorGoogleAccessLink))),
        })),
        React.createElement(PeekTypography, null, intl.formatMessage(messages.spacePublishToGMBAuthErrorDescription2))));
};
export default GoogleMyBusinessAuthError;
